// extracted by mini-css-extract-plugin
export default {"button":"styles_button__blBku","disabled":"styles_disabled__KRfka"};